import { useUser as useUserCore } from '@ztechapps/common.hook'

//NOTE: WE cannot use here the value from the web-ui because of it's dependency on local storage, and this app need SSR
//TODO: We can fixt his and use useUser
export const useUser = ({ ...rest } = {}) => {
  return useUserCore(rest)
}
